import React from "react";

const BS5_DarkMode = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_DarkMode Component</h2>
      <p>This is the BS5_DarkMode component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_DarkMode;
